import { AutogenLayoutPayee401kFundLookup } from "./autogen/AutogenLayoutPayee401kFundLookup";

export class Payee401kFundLookup extends AutogenLayoutPayee401kFundLookup {
}
